
<!--
/**
  * 自定义布局的表单组件
  * @author weili
  * @date 2022-11-3
  */
-->
<template>
<div class="content">
    <div class="submodel">
     <div class="form">
        <el-form ref="form"
            :class="className"
            :model="formData"
            :rules="rulesparams"
            :label-width="labelWidth"
            :size="curSize"
            >
         <div v-for="(row, index) in formList"
                  v-if="
                        typeof row.show === 'function'
                        ? row.show(row.showIsValid, formData)
                        : row.show == false?false:true
                    "
            :key="index">
            <div  style="display: flex;width:100%;">
                <div :style="firstWidth"></div><!--标签前增加间距-->
                <el-form-item
                    v-for="(item, i) in row.rowConfig"
                    v-if="
                        typeof item.show === 'function'
                        ? item.show(item.showIsValid, formData)
                        : item.show == false?false:true
                    "
                    :key="i"
                    :label="item.label"
                    :prop="item.value"
                    :class="item.className"
                    :style="item.style"
                    >
                      <!-- solt -->
                    <template v-if="item.type === 'slot'">
                      <slot :name="'form-' + item.value" :value="item" />
                    </template>
                     <!-- 普通输入框 -->
                     <el-input
                        v-if="item.type === 'input'"
                        :placeholder="convertPlaceholder(item)"
                        v-model="formData[item.value]"
                       :disabled="item.disabled"
                        :clearable="item.clearable==false?false:true"
                        :readonly="item.readonly"
                        :maxlength="item.maxlength"
                        @focus="
                          handleEvent(
                            item.event,
                            formData[item.value],
                            item.label,
                            item.multiple,
                            item.value
                          )
                        "
                        @change="
                          handleEvent(
                            item.event,
                            formData[item.value],
                            item.label,
                            item.multiple,
                            item.value
                          )
                        "
                        style="width:100%"
                      >
                      <template v-if="item.slotType" :slot="item.slotType">{{item.slotText}}</template>
                      <el-button v-reClick
                        v-if="item.hasBtn"
                        slot="append"
                        :icon="item.btnIcon"
                        @click="handleEvent(item.btnEvent)"
                      ></el-button>
                    </el-input>
                    <!-- 文本输入框 -->
                    <el-input
                        v-if="item.type === 'textarea'"
                        v-model="formData[item.value]"
                        type="textarea"
                        :disabled="item.disabled"
                        :clearable="item.clearable==false?false:true"
                         :placeholder="convertPlaceholder(item)"
                        :rows="item.rows?item.rows:4"
                        :maxlength="item.maxlength"
                        show-word-limit
                        @focus="
                          handleEvent(
                            item.event,
                            formData[item.value],
                            item.label,
                            item.multiple,
                            item.value
                          )
                        "
                        style="width:100%;"
                    />


                     <!-- 数字输入框 -->
                    <el-input-number  v-if="item.type === 'number'"
                        v-model="formData[item.value]"
                        :min="item.min"
                        :max="item.max"
                        :disabled="item.disabled"
                        :placeholder="convertPlaceholder(item)"
                        @change="
                          handleEvent(
                            item.event,
                            formData[item.value],
                            item.label,
                            item.multiple,
                            item.value
                          )
                        "
                        style="width:100%"
                        >
                    </el-input-number>
                    <span v-if="item.type === 'number' && item.tag">&nbsp;{{item.tag}}</span>

                    <!-- 带单位的计数器 -->
                    <el-input v-if="item.type === 'counterUnit'"
                     :placeholder="convertPlaceholder(item)"
                    v-model="formData[item.value]"
                    type="number"
                    style="width:100%"/>
                    <span v-if="item.type === 'counterUnit' && item.tag">&nbsp;{{item.tag}}</span>
                    <!-- <span class="minute">{{typeof item.unit === "function" ? item.unit(formData) : item.unit}}</span> -->

                      <!-- 选择框 -->
                    <el-select
                        v-if="item.type === 'select'"
                        v-model="formData[item.value]"
                        :multiple="item.multiple"
                        :disabled="item.disabled"
                        :clearable="item.clearable==false?false:true"
                        :filterable="item.filterable"
                         :placeholder="convertPlaceholder(item)"
                        :remote="item.remote"
                        :remote-method="item.remoteMethod"
                        :class="{'is-select-success':item.isSelectSuccess}"
                        @change="
                          handleEvent(
                            item.event,
                            formData[item.value],
                            listTypeInfo[item.list],
                            item.multiple,
                            item.value,
                            item
                          )
                        "
                        @clear="
                          handleEvent(
                            item.clear,
                            formData[item.value],
                            listTypeInfo[item.list],
                            item.multiple,
                            item.value,
                            item
                          )
                        "
                        style="width:100%"
                        >
                       <el-option
                          v-for="(childItem, childIndex) in listTypeInfo[item.list]"
                          :key="childIndex"
                          :label="childItem.label"
                          :value="childItem.value"
                        >
                         <span class="content-wrap" :title="childItem.label">{{ childItem.label }}</span>
                         <span v-for="(btn, idx) in item.optionBtns" :key="idx"
                            style="float: right; color: #8492a6; font-size: 13px"
                            @click.stop="btn.handle(childItem[btn.field],childItem.label,childIndex)"><i :class="btn.icon" /></span>
                        </el-option>
                    </el-select>

                    <!-- 树形选择框 -->
                    <EXSelectTree
                      v-if="item.type === 'tree'"
                      :ref="`exSTree-${item.value}`"
                      :formData="formData"
                      :value="item.value"
                      :data="item.treeData"
                      :defaultProps="{ children: 'children',label: item.defaultProps.dataName}"
                      :multiple="item.multiple"
                      :placeholder="convertPlaceholder(item)"
                      :clearable="item.clearable"
                      :nodeKey="item.defaultProps.dataCode"
                      :checkStrictly="item.checkStrictly"
                      :expandOnClickNode="item.expandOnClickNode"
                      :isShowFilter="item.isShowFilter"
                      :defaultExpandAll="item.defaultExpandAll"
                      :isOnlyLeaf="item.isOnlyLeaf"
                      :size="curSize"
                      @change="
                      (value) => handleEvent( item.event,value,item.label,item.multiple,item.value)"
                    />
                    <!-- 图片上传 -->
                    <EXUploadImg
                      :ref="`image-${item.value}`"
                      v-if="item.type === 'image'"
                      @update-image="updateImage"
                      @remove-image="removeImage"
                      :updateData="item.updateData?item.updateData:updateImg"
                      :limit="item.limit"
                      :itemValue="item.value"
                      style="width:100%">
                    </EXUploadImg>
                    <!-- 附件上传 -->
                    <EXUploadFile
                        :ref="`file-${item.value}`"
                        v-if="item.type === 'file'"
                        @update-attachment="updateAttachment"
                        @remove-attachment="removeAttachment"
                        style="width: 100%"
                        :updateData="item.updateData?item.updateData:updateFile"
                        :drag="true"
                        :limit="item.limit"
                        :itemValue="item.value"
                    ></EXUploadFile>

                    <!-- 日期选择框DatePicker -->
                    <el-date-picker
                        v-if="item.type === 'date'"
                        v-model="formData[item.value]"
                        :type="item.dateType"
                        :picker-options="item.TimePickerOptions"
                        :disabled="item.disabled"
                        :clearable="item.clearable==false?false:true"
                        :value-format="item.valueFormat"
                        :format="item.format"
                        :range-separator="item.separator"
                        :start-placeholder="item.startPH"
                        :end-placeholder="item.endPH"
                        :default-time="item.defaultTime"
                         :placeholder="convertPlaceholder(item)"
                        @change="
                          handleEvent(
                            item.event,
                            formData[item.value],
                            item.label,
                            item.multiple,
                            item.value
                          )
                        "
                        style="width:100%"
                    />

                      <!-- 时段选择框DatePicker -->
                      <el-time-select
                        v-if="item.type === 'time'"
                        v-model="formData[item.value]"
                        :picker-options="item.TimePickerOptions"
                        :disabled="item.disabled"
                        :clearable="item.clearable==false?false:true"
                        :value-format="item.valueFormat"
                        :format="item.format"
                        :start-placeholder="item.startPH"
                        :end-placeholder="item.endPH"
                        :placeholder="convertPlaceholder(item)"
                        @change="
                          handleEvent(
                            item.event,
                            formData[item.value],
                            item.label,
                            item.multiple,
                            item.value
                          )
                        "
                        style="width:100%"
                    />

                    <!-- 单选选择 -->
                    <el-radio-group
                        v-if="item.type === 'radio'"
                         :placeholder="convertPlaceholder(item)"
                        v-model="formData[item.value]"
                        :disabled="item.disabled"
                        @change="
                          handleEvent(
                            item.event,
                            formData[item.value],
                            listTypeInfo[item.list],
                            item.multiple,
                            item.value
                          )
                        "
                        style="width:100%"
                    >
                        <el-radio
                        v-for="(childItem, childIndex) in listTypeInfo[item.list]"
                        :key="childIndex"
                        :label="childItem.value"
                        :style="{'line-height':curSize==='mini'?'0.28rem':curSize==='medium'?'0.38rem':'0.34rem'}"
                        >
                        {{   childItem.label }}</el-radio
                        >
                    </el-radio-group>
                    <!-- 文本展示框 -->
                    <span v-if="item.type === 'text' && curSize==='small'"  style="width:100%;line-height:0.16rem;padding-top:0.08rem" :style="item.cssStyle" class="text-font"
                    >{{ formData[item.value] }}</span>
                    <span v-if="item.type === 'text' && curSize==='mini'"  style="width:100%;line-height:0.12rem;padding-top:0.08rem" :style="item.cssStyle" class="text-font"
                    >{{ formData[item.value] }}</span>
                    <span v-if="item.type === 'text' && curSize==='medium'"  style="width:100%;line-height:0.19rem;padding-top:0.08rem" :style="item.cssStyle" class="text-font"
                    >{{ formData[item.value] }}</span>
                    <!--滑块开关-->
                     <el-switch
                        v-if="item.type === 'switch'"
                        v-model="formData[item.value]"
                        :disabled="item.disabled"
                        :active-text="item.activeText"
                        :inactive-text="item.inactiveText"
                        active-value="1"
                        inactive-value="0"
                        @change="
                          handleEvent(
                            item.event,
                            formData[item.value],
                            item.label,
                            item.multiple,
                            item.value
                          )
                        "
                        active-color="#13ce66"
                        :style="{'width':'100%','height':curSize=='mini'?'0.28rem':curSize==='medium'?'0.38rem':'0.34rem'}"
                      ></el-switch>
                      <!--多选框-->
                      <el-checkbox-group
                          v-if="item.type === 'checkbox'"
                          v-model="formData[`${item.value}Group`]"
                          :disabled="item.disabled"
                          @change="
                            handleCheckboxClick(
                              item.event,
                              formData[`${item.value}Group`],
                              item.value
                            )
                          "
                          style="width:100%"
                          >
                          <el-checkbox v-for="childItem in listTypeInfo[item.list]"
                           :label="childItem.label" :key="childItem.value"></el-checkbox>
                      </el-checkbox-group>
                      <!--滑块多选框-->
                      <el-checkbox-group
                          v-if="item.type === 'checkbutton'"
                          v-model="formData[`${item.value}Group`]"
                          :disabled="item.disabled"
                          @change="
                            handleCheckbuttonClick(
                              item.event,
                              formData[`${item.value}Group`],
                              item.value
                            )
                          "
                          style="width:100%"
                          >
                          <el-checkbox-button v-for="childItem in listTypeInfo[item.list]"
                           :label="childItem.value" :key="childItem.value">{{childItem.label}}</el-checkbox-button>
                      </el-checkbox-group>
                        <!-- 注释文字-->
                        <div v-if="item.type =='info'" :style="item.infoStyle">
                            <div class="table-desc">
                                <div class="tips">
                                      <img alt="" />
                                      <span style="color: #333; margin-left: 0.06rem"
                                        >{{ item.value }}</span>
                                </div>
                            </div>
                         </div>

			                <!--富文本编辑器-->
                      <quill-editor
                        v-if="item.type === 'texteditor'"
                            v-model="formData[item.value]"
                            class="ql-editor-class"
                            :ref="`quillEditor-${item.value}`"
                            :options="{placeholder:item.placeholder?item.placeholder:`请输入${item.label}`}"
                            @ready="onEditorReady(item)"
                            @change="onEditorChange($event,item)">
                      </quill-editor>
                      <span v-if="item.type === 'texteditor'"
                        class="ql-editor-class-count">
                         {{TiLength}}/{{item.maxlength}}</span>

                      <!--单行操作按钮-->
                        <el-button v-reClick
                          v-for="(it, index) in item.operationHandle"
                          :key="index"
                          :plain="it.plain || false"
                          :type="it.type || 'primary'"
                          :icon="it.icon || ''"
                          :size="it.size || 'medium'"
                          @click="it.handle()"
                          >{{ it.label }}</el-button>
                </el-form-item>
                 <!-- 每行操作按钮 -->
                  <el-form-item v-if="rowHasButton">
                      <el-button v-reClick
                        v-for="(item, index) in rowOperationHandle"
                        :key="index"
                        :plain="item.plain || false"
                        :type="item.type || 'primary'"
                        :icon="item.icon || ''"
                        :size="item.size || 'medium'"
                        @click="item.handle(row.index)"
                        >{{ item.label }}</el-button
                      >
                  </el-form-item>
                  <div :style="lastWidth"></div>
                </div>
          </div>
          <!-- 底部操作按钮 -->
           <br/>
            <div v-if="bottomBtnProps"  :style="{'display': 'flex','width':bottomBtnProps.width?bottomBtnProps.width:'100%'}">
                   <div :style="firstWidth"></div>
                    <el-col :span="24" :style="{'text-align':bottomBtnProps.align?bottomBtnProps.align:'center'}">  <!--设置按钮对齐方式-->
                            <el-button v-reClick
                                v-for="(item, index) in bottomBtnProps.operationHandle"
                                :key="index"
                                :plain="item.plain || false"
                                :type="item.type || 'primary'"
                                :icon="item.icon || ''"
                                :size="item.size || 'medium'"
                                style="margin-right:10px"
                                @click="item.handle()"
                                >{{ item.label }}</el-button>
                      </el-col>
                  <div :style="lastWidth"></div>
              </div>
              <br/>
        </el-form>
    </div>
</div>
</div>
</template>
<script>
import mixin from '@/mixins/mixin'
import * as attachApi from '@/api/gate/attach/index'
import EXSelectTree from "@/components/EXForm/EXSelectTree";
import EXUploadImg from "@/components/EXUpload/uploadImg";
import EXUploadFile from "@/components/EXUpload/uploadFile";
export default {
    name: 'EXForm',
    components: {
        EXSelectTree,
        EXUploadImg,
        EXUploadFile
    },
   mixins: [mixin],
   props: {
      //  api:null,           //附件查询接口方法
       formData: {
       type: Object,
       default: {},
       },
       className: {
        type: String,
        default: "",
      },
      labelWidth: {
        type: String,
        default: "1.6rem",
      },
      firstWidth: {
        type: String,
        default: "width:5%",
      },
      lastWidth :{
        type: String,
        default: "width:0",
      },
      rules: {
        type: Object,
        default: {},
      },
      // el-form的数据
      formList: {
        type: Array,
        default: [],
      },
      // 下拉框选择值
      listTypeInfo: {
        type: Object,
        default: {},
      },
      fatherEvent: Function,
      // 操作按钮的数据
      bottomBtnProps:Object,
      // 每行操作按钮的数据
      rowHasButton: {
        type: Boolean,
        default: false,
      },
      rowOperationHandle: {
        type: Array,
        default: () => [],
      },
      fatherEvent: Function,
      oldFiles: { //记录旧附件
        type: Array,
        default: () => [],
      },
      removeFiles: { //待删除文件
        type: Array,
        default: () => [],
      },
      oldImages: {  //记录旧图片
        type: Array,
        default: () => [],
      },
      removeImages: {  //待删除图片
        type: Array,
        default: () => [],
      },
      size:{  //表单尺寸medium / small / mini
        type: String,
        default: "medium",
      }
   },
   created(){
        this.initListTypeInfo()
        this.initAttachInfo()
   },
   mounted(){

   },
   computed: {
        rulesparams() {
        let rules = {};
        // this.formList.map((item) => {
        //     if (
        //     typeof item.show === "function"
        //         ? item.show(item.showIsValid, this.formData)
        //         : item.show
        //     ) {
        //     let key = item.value;
        //     return (rules[key] = item.rule);
        //     }
        // });
        this.formList.map((row) => {
            row.rowConfig.map((item) => {
                if (
                typeof item.show === "function"
                    ? item.show(item.showIsValid, this.formData)
                    : item.show == false?false:true
                ) {
                let key = item.value;
                return (rules[key] = item.rule);
                }
            });
        });
        console.log("rules", rules);
        return rules;
        },
    curSize() {
       return this.size;
    },
   },
   data() {
        return {
            drag: false,
            //默认的文件上传配置
            updateFile: {
                updateMsg: '支持格式：doc、docx、ppt、pptx、xls、xlsx、pdf 、jpg、png、jpeg、mp4，单个文件不能超过20MB，默认最多5个文件',
                updateTypeMsg: '支持格式： .doc .docx .ppt .pptx .xls .xlsx .pdf .jpg .png .jpeg .mp4',
                updateSizeMsg: '单个文件不能超过20MB',
                updateSize: 20971520,
                fileType: '.doc,.docx,.ppt,.pptx,.xls,.xlsx,.pdf,.jpg,.png,.jpeg,.mp4,.DOC,.DOCX,.PPT,.PPTX,.XLS,.XLSX,.PDF,.JPG,.PNG,.JPEG,.MP4'
            },
            //默认的图片上传配置
            updateImg: {
                updateMsg: '支持格式：jpg、png、jpeg、mp4，单个图片不能超过10M，默认最多5个图片或视频',
                updateTypeMsg: '支持格式： .jpg,.png,.jpeg,.mp4',
                updateSizeMsg: '单个文件不能超过10MB',
                updateSize: 10485760,
                fileType: '.jpg,.png,.jpeg,.mp4,.JPG,.PNG,.JPEG,.MP4'
            },
            TiLength:0 //当前编辑器输入的字数
        };
  },
  watch: {
    formData (val) {
      this.initListTypeInfo()
      this.initAttachInfo()
    },
    formList(val){
      this.initListTypeInfo()
      this.initAttachInfo()
    },
    listTypeInfo(val){
      this.initListTypeInfo()
    }
  },
   methods: {
        //初始化字典下拉框和其他属性
        initListTypeInfo(){
          this.formList.map((row) => {
              row.rowConfig.map((item) => {
                  if(item.dicCode && item.dicCode.trim().length > 0){
                   this.mixFeignDictDataList(item.dicCode).then((list)=>{
                        // this.listTypeInfo[item.list] = list
                        this.$set(this.listTypeInfo, item.list,list)
                        this.$forceUpdate()
                        if(item.type == 'select' || item.type == 'checkbutton' || item.type == 'checkbox'){  //字典下拉框显示项筛选
                          this.handleSelectOptions(item)
                        }
                    })
                  }else{
                    if(item.type == 'select' || item.type == 'checkbutton' || item.type == 'checkbox'){  //普通下拉框显示项筛选
                      this.handleSelectOptions(item)
                    }
                  }
                  if(item.type == 'checkbutton'){  //多选框要把数值转换成value数组
                    var value = this.formData[item.value]
                    let ids = []
                    if (value) {
                      ids = value.split(',')
                    }
                    this.$set(this.formData, `${item.value}Group`, ids);
                    this.$forceUpdate()
                  }
                  if(item.type == 'checkbox'){  //多选框要把数值转换成label数组
                    var value = this.formData[item.value]

                    let ids = []
                    let labels = []
                    if (value) {
                      ids = value.split(',')
                    }
                    const list = this.listTypeInfo[item.list]
                    for(let i = 0;i<ids.length;i++){
                      const e = list.find(e => e.value === ids[i]);
                      if(e){
                        labels.push(e.label)
                      }
                    }
                    this.$set(this.formData, `${item.value}Group`, labels);
                    this.$forceUpdate()
                  }
              });
          });
        },
        //设置下拉框选项显示/隐藏
        handleSelectOptions(item){
          const list =  this.listTypeInfo[item.list]
          if(item.showOptions && item.showOptions.length > 0){
            let data = []
            for(var i = 0; i < list.length; i++){
              for(var j = 0; j < item.showOptions.length; j++){
                  if(list[i].value == item.showOptions[j]){
                        data.push(list[i])
                        break;
                  }
              }
            }
            this.$set(this.listTypeInfo, item.list, data)
            this.$forceUpdate()
          }
          if(item.hideOptions && item.hideOptions.length > 0){
            let data = []
            data = data.concat(list)  //浅拷贝，避免修改字典数组
            for(var i = 0; i < list.length; i++){
              for(var j = 0; j < item.hideOptions.length; j++){
                  if(list[i].value == item.hideOptions[j]){
                        data.splice(i, 1);
                        break;
                  }
              }
            }
            this.$set(this.listTypeInfo, item.list, data)
            this.$forceUpdate()
          }
        },
        //初始化附件
        initAttachInfo(){
          // if (!this.api) return
          this.formList.map((row) => {
            row.rowConfig.map((item) => {
              if(item.objectId && item.objectId != '' && item.objectType && item.objectType != ''){
                var id = this.formData[item.objectId]
                if (id) {
                   const params = {
                     objectId: id,
                     objectNamespace: item.objectType
                   }
                   if(params.objectId && params.objectNamespace){
                      attachApi.getAttachmentList(params).then((res)=>{
                        let body = res && res.body ? res.body : null
                        if(!body){
                            let data = res && res.data ? res.data : {}
                            body = data && data.body ? data.body : {}
                        }
                        const list = body.list || []
                        this.formData[item.value] = list
                        if(item.type == 'image'){
                          this.$emit('update-images', list)
                          this.initImageList(list, item)  //调用图片组件赋值
                        }else{//file
                          this.$emit('update-files', list)
                          this.initAttachmentList(list, item) //调用附件组件赋值
                        }
                    })
                   }
                }
               }
            })
          })
        },
        // 查询(数据预览)
        search() {
            this.$emit("handleSearch");
        },
        handleClick(itemEvent, $event) {
          this.$emit("handleClick", itemEvent, $event);
        },
        // 绑定的相关事件
        handleEvent(event, value, label, multiple, field,item) {
          if(value && item && item.type=='select'){
            item.isSelectSuccess = true
             this.$forceUpdate();
          }else if(item && item && item.type=='select' && !value){
             item.isSelectSuccess = false
              this.$forceUpdate();
          }
          let labelText = ''
          if(label && Array.isArray(label)){
            let obj  ={}
            obj =  label.find((item)=>{return item.value ===value})
            if(obj!==undefined){
              labelText = obj.label
            }
          }else{
            labelText = label
          }
          event && typeof event === "function"
            ? event(value, labelText, field)
            : this.$emit("fatherEvent", event, value, labelText, multiple, field);
        },
         // 绑定的相关事件
         handle(event, value, label, multiple, field) {
          let labelText = ''
          if(label && Array.isArray(label)){
            let obj  ={}
            obj =  label.find((item)=>{return item.value ===value})
            if(obj!==undefined){
              labelText = obj.label
            }
          }else{
            labelText = label
          }
          event && typeof event === "function"
            ? event(value, labelText, field)
            : this.$emit("fatherEvent", event, value, labelText, multiple, field);
        },
        //多选回调事件
        handleCheckboxClick(event, value, name){
          //将数组group值转换成字符串
          var str = value.join()
          this.$set(this.formData, name, str); //回填表单值
          this.$forceUpdate();
          if(event && typeof event === "function"){
            event(str)
          }
        },
        //滑块多选回调事件
        handleCheckbuttonClick(event, value, name){
          //将数组group值转换成字符串
          var str = value.join()
          this.$set(this.formData, name, str); //回填表单值
          this.$forceUpdate();
          if(event && typeof event === "function"){
            event(str)
          }
        },
        //文件上传相关方法
        updateAttachment(attachment,itemValue) {
            this.formData[itemValue] = attachment
        },
        initAttachmentList(attachment,item){
            this.$refs[`file-${item.value}`][0].initAttachmentList(attachment) //调用附件组件渲染
        },
        removeAttachment(attachment,file,itemValue) {
            this.formData[itemValue] = attachment
            this.$emit('remove-file', file)
        },
        updateImage(img,itemValue){
          this.formData[itemValue] = img
        },
        initImageList(img,item){
            this.$refs[`image-${item.value}`][0].initImageList(img) //调用图片组件渲染
        },
        removeImage(img,file,itemValue) {
            this.formData[itemValue] = img
            this.$emit('remove-image', file)
        },
 	      onEditorReady(item){
          var editor = this.$refs[`quillEditor-${item.value}`][0];
          if(editor && editor.quill){
             this.TiLength = editor.quill.getLength()-1;
          }
        },
        onEditorChange(event,item) {
          event.quill.deleteText(item.maxlength,1);
          this.TiLength = event.quill.getLength()-1;
          if(this.TiLength == 0){
            event.quill.setText('')
          }
          this.$refs.form.validateField(item.value);
        },
        resetEXSTree(field,text){
          this.$refs[`exSTree-${field}`][0].selectedData = text
        },
        convertPlaceholder(item){
          if(item.placeholder){
            return item.placeholder;
          }else{
            let label = item.label
            if(label){
              label = label.trim();
              if(label.length>0){
                let lastChart = label.slice(-1);
                if(lastChart == '：'||lastChart==':'){
                  label = label.slice(0,label.length-1)
                }
              }
            }
            let str = ''
            if(item.type=='input' || item.type=='textarea' || item.type == 'counterUnit'){
              str = '请输入'
            }else if(item.type=='select' || item.type=='number' ||item.type=='tree' || item.type == 'radio' || item.type == 'date' || item.type == 'time'){
               str = '请选择'
            }
            return str+label
          }
          
        }
   },
}
</script>
<style lang="scss" scoped>
@import '../../styles/variables.scss';
// .tabs-box {
//   display: flex;
//   padding-left: 0.2rem;
//   .title {
//     color: #333;
//     border-bottom: 0.02rem solid #2153c0;
//     margin-right: 0.2rem;
//     padding-bottom: 0.1rem;
//     &:hover {
//       cursor: pointer;
//       color: #2153c0;
//     }
//   }
// }
.content {
  margin-top: 0.1rem;
  .submodel {
    .headline {
      &::before {
        content: "";
        display: inline-block;
        width: 0.13rem;
        height: 0.13rem;
        border-radius: 100%;
        background: #2153c0;
        margin-right: 0.1rem;
        margin-left: 0.2rem;
      }
      .title {
        font-weight: bold;
      }
      .desc {
        color: #666;
      }
    }
    .form {
      // margin: 0.2rem;
      // padding: 0.1rem;
      // border: 1px solid #d9d9d9;
      width:100%;
      .title {
        font-weight: 500;
      }
      /deep/ .el-form-item__content {
        display: flex;
      }
      // /deep/ .el-form-item {
      //   margin-bottom: 8px !important;
      // }
      // .option-content {
      //   /deep/ .el-input {
      //     width: 72.5%;
      //     margin-right: 0.2rem;
      //   }
      // }

      .total-score {
        .el-radio-group {
          margin-top: 0.05rem;
          margin-bottom: 0.2rem;
        }
        // /deep/ .el-input {
        //   width: 35.5%;
        //   margin-right: 0.2rem;
        // }
        // /deep/ .el-input__inner{
        //   width: 80%;
        // }
      }
    }
  }
}
//注释文字样式
.tips {
      display: flex;
      align-items: center;
      img{
        width: .16rem;
        @include top_desc_img('tip.png');
      }
    }
.text-font{
  @include font_color($font-colorD);
}
.table-desc {
  width: 100%;
  padding-left: .14rem;
  padding-right: .2rem;
  margin: 0;
  height: .4rem;
  line-height: .4rem;
  display: flex;
  justify-content: space-between;
  @include top_desc_bg($top-desc-bgD);
  @include top_desc_border($top-desc-borderD);
  span {
    // font-size: .16rem;
    // font-family: Microsoft YaHei;
    font-weight: 400;
  }
}
//操作按钮加手指样式
/deep/ .el-input__inner{
  /*cursor: pointer;*/
}
.el-input-group__append{
  cursor: pointer;
}
/deep/ .el-range-input{
  cursor: pointer;
}
//富文本样式
.ql-editor-class {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 1.42;
  height: 3.45rem;
  width: 100%;
  outline: none;
  padding: 0 !important;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  word-wrap: break-word;
}
.ql-editor-class-count{
  line-height: 0.1rem;
  color: #909399;
  background: #FFF;
  position: absolute;
  font-size: 12px;
  bottom: 0.2rem;
  right: 10px;
}
</style>
<style lang="scss">
.ql-container {
  height: 3rem;
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
//修改多选下拉框样式
.el-select-dropdown.is-multiple .el-select-dropdown__item{
  padding-right: 0 !important;
}

.content-wrap{
    float: left;
    display: inline-block;
    max-width: 2.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .is-select-success .el-input__inner {
    border-color: #67c23a; /* 绿色 */
  }
</style>



// WEBPACK FOOTER //
// src/components/EXForm/index.vue